import React, { ReactNode } from "react"
import styled from "styled-components"
import { theme } from "../../../theme"

export type PageHeaderActionsProps = {
  children?: ReactNode
  className?: string
}

/*
 * @deprecated This component will be replaced by Header component
 */
export const PageHeaderActions = (props: PageHeaderActionsProps) => {
  const { className, children } = props

  return <Root className={className}>{children}</Root>
}

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${theme.spacing.m};
  width: 100%;

  > * {
    margin-left: ${theme.spacing.l};

    &:first-child {
      margin-left: 0px;
    }
  }

  ${theme.mui.breakpoints.up("md")} {
    margin-top: 0;
    width: auto;
  }
`
